import { Hint } from 'CorePackage/MainModule/components/Hint';

interface IErknmFillInProcessMessageProps {
  isActive: boolean;
}

export const CanBeChangedInNonWorkDaysMessage = ({ isActive }: IErknmFillInProcessMessageProps) => {
  if (isActive) {
    return <Hint text="При проведении КНМ в нерабочие дни поле подлежит изменению" />;
  }

  return null;
};
